import { mainApi } from "services/main";
import {
  TaskListRequest,
  TaskListResponse,
  CreateWithTemplateResponse,
  CreateWithTemplateRequest,
  CreateTasksFromScanRequest,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaskList: builder.query<TaskListResponse, TaskListRequest>({
      query: (request: TaskListRequest) => ({
        url: "tasks-children",
        body: request,
        method: "POST",
      }),
    }),
    createTasks: builder.mutation<
      CreateWithTemplateResponse,
      CreateWithTemplateRequest | CreateTasksFromScanRequest
    >({
      query: (
        request: CreateWithTemplateRequest | CreateTasksFromScanRequest
      ) => ({
        url: "tasks-from-template",
        body: request,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTaskListQuery,
  useLazyGetTaskListQuery,
  useCreateTasksMutation,
  usePrefetch,
} = extendedApi;
